module.exports = __webpack_public_path__ + "static/media/medkit.abb2358e.svg";